import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(Box)(() => ({
  width: '100%',
  textTransform: 'uppercase',

  '.MuiTypography-root': {
    fontWeight: 500,
  },
}));
